import { atom } from 'jotai';

export const isMetricFiltersModalOpenAtom = atom(false);
